// Cognito認証設定

export interface CognitoConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  domain: string;
  redirectSignIn: string;
  redirectSignOut: string;
  responseType: string;
}

// 環境変数からCognito設定を取得
const getCognitoConfig = (): CognitoConfig => {
  return {
    region: process.env.REACT_APP_COGNITO_REGION || 'ap-northeast-1',
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'ap-northeast-1_p2camqUyo',
    userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || '3qbpdetkmjd1bqh4u0g8f1eqvg',
    domain: process.env.REACT_APP_COGNITO_DOMAIN || 'https://ragapplication-ootsubo-auth.auth.ap-northeast-1.amazoncognito.com',
    redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || 'http://localhost:3000/callback',
    redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || 'http://localhost:3000',
    responseType: 'code'
  };
};

// Amplify用の設定オブジェクト（v6対応）
export const amplifyConfig = {
  Auth: {
    Cognito: {
      region: getCognitoConfig().region,
      userPoolId: getCognitoConfig().userPoolId,
      userPoolClientId: getCognitoConfig().userPoolClientId,
      loginWith: {
        oauth: {
          domain: getCognitoConfig().domain.replace('https://', ''),
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [getCognitoConfig().redirectSignIn],
          redirectSignOut: [getCognitoConfig().redirectSignOut],
          responseType: getCognitoConfig().responseType as 'code'
        }
      }
    }
  }
};

// 設定のインスタンス
export const cognitoConfig = getCognitoConfig();

// デバッグ用の設定表示
if (process.env.NODE_ENV === 'development') {
  console.log('[DEBUG] Cognito Config:', {
    region: cognitoConfig.region,
    userPoolId: cognitoConfig.userPoolId,
    userPoolClientId: cognitoConfig.userPoolClientId,
    domain: cognitoConfig.domain,
    redirectSignIn: cognitoConfig.redirectSignIn,
    redirectSignOut: cognitoConfig.redirectSignOut
  });
}
